import { useCallback, useState } from 'react';

export type Tema = 'sistema' | 'claro' | 'oscuro';
const CLAVE = 'bb-tema';

function leer(): Tema {
  try {
    const guardado = localStorage.getItem(CLAVE);
    return guardado === 'claro' || guardado === 'oscuro' ? guardado : 'sistema';
  } catch {
    return 'sistema';
  }
}

function aplicar(tema: Tema): void {
  if (tema === 'sistema') delete document.documentElement.dataset.tema;
  else document.documentElement.dataset.tema = tema;
}

/** Tema claro/oscuro con preferencia guardada por navegador (solo comodidad del usuario). */
export function useTema() {
  const [tema, setTema] = useState<Tema>(leer);
  const cambiarTema = useCallback((nuevo: Tema) => {
    setTema(nuevo);
    aplicar(nuevo);
    try {
      if (nuevo === 'sistema') localStorage.removeItem(CLAVE);
      else localStorage.setItem(CLAVE, nuevo);
    } catch {
      /* sin almacenamiento: el tema dura solo esta sesión */
    }
  }, []);
  return { tema, cambiarTema };
}
